import http from '../../../Utils/http';
const ResetPasswordCode = {
  name: 'resetPasswordCode',
  state: {
    loading: false,
    error: '',
    permissions: [
      'organization:view',
      'organization:create',
      'organization:delete',
      'organization:update',
    ],
  },
  reducers: {
    resetPasswordCodeRequested(state){
      return {
        ...state,
        loading: true,
        error: '',
        message:''
      };
    },
    resetPasswordCodeRequestReceived(state,payload){
      return {
        ...state,
        loading:false,
        message:payload,
        error:'',
      }
    },
    resetPasswordCodeRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
        message:'',
        loading:false,
      };
    },

  },
  effects: (dispatch) => ({
   async requestForResetPasswordCode(data) {
        try {
          this.resetPasswordCodeRequested();
          const response = await http.post(`/auth/request-reset-password`, data);
          this.resetPasswordCodeRequestReceived(response.data.message);
        } catch (err) {
          this.resetPasswordCodeRequestFailed(err.response.data.error)
          dispatch({
            type: 'helper/show',
            payload: {
              type: 'error',
              message: 'Invalid Credentials',
              open: true,
            },
          });
        }
      },
      async clearData() {
        this.resetPasswordCodeRequestReceived('');
      }
  }),
};

export default ResetPasswordCode;